import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center gap-5" }
const _hoisted_2 = { class: "text-muted-foreground w-full text-xs font-medium" }
const _hoisted_3 = { class: "grid auto-cols-fr grid-flow-col" }

import { ListChecks, X } from 'lucide-vue-next';
    import {
        PopoverClose,
        PopoverContent,
        PopoverPortal,
        PopoverRoot,
        PopoverTrigger,
    } from 'reka-ui';
    import { useI18n } from 'vue-i18n';
    import { computed, ref } from 'vue';
    import { Button } from '@/components/ui/button';
    import OnboardingGuideItem from './OnboardingGuideItem.vue';
    import OnboardingAssistantModal from './OnboardingAssistantModal.vue';
    import type { OnboardingStep } from '@/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'OnboardingGuide',
  props: {
    onboardingSteps: {},
    companyId: {}
  },
  setup(__props: any, { expose: __expose }) {

    const { t } = useI18n();

    const props = __props;

    const steps = computed(() => {
        return [...props.onboardingSteps].sort((a, b) => {
            if (a.is_completed && !b.is_completed) return 1;
            if (!a.is_completed && b.is_completed) return -1;
            return 0;
        });
    });

    const open = ref(false);
    const assistantOpen = ref(false);

    const openModal = () => {
        assistantOpen.value = true;
        open.value = false;
    };

    __expose({
        assistantOpen,
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(PopoverRoot), { open: open.value }, {
      default: _withCtx(() => [
        _createVNode(_unref(PopoverTrigger), {
          class: "text-foreground hover:text-accent focus:text-accent inline-flex cursor-pointer items-center justify-center",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (open.value = !open.value))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ListChecks))
          ]),
          _: 1
        }),
        _createVNode(_unref(PopoverPortal), null, {
          default: _withCtx(() => [
            _createVNode(_unref(PopoverContent), {
              side: "bottom",
              "side-offset": 5,
              "avoid-collisions": "",
              "collision-padding": 10,
              class: "animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 min-w-60 rounded border bg-white p-4 shadow-sm will-change-[transform,opacity]"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(t)('onboarding.guide.title')), 1),
                  _createElementVNode("div", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(steps.value, (step) => {
                      return (_openBlock(), _createBlock(OnboardingGuideItem, {
                        key: step.id,
                        "onboarding-step": step
                      }, null, 8, ["onboarding-step"]))
                    }), 128))
                  ]),
                  _createVNode(_unref(Button), {
                    variant: "default",
                    onClick: openModal
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('onboarding.complete')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_unref(PopoverClose), {
                  class: "ring-offset-background focus:ring-ring data-[state=open]:bg-accent data-[state=open]:text-muted-foreground absolute top-4 right-4 rounded-xs opacity-70 transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 focus:outline-hidden disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
                  "aria-label": "Close",
                  tabindex: "-1",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (open.value = false))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(X))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(OnboardingAssistantModal, {
      "onboarding-steps": steps.value,
      modelValue: assistantOpen.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((assistantOpen).value = $event)),
      "company-id": _ctx.companyId
    }, null, 8, ["onboarding-steps", "modelValue", "company-id"])
  ], 64))
}
}

})